import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VMenu,{attrs:{"top":"","offset-y":"","nudge-top":"10"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",null,null,{ on, attrs })]}}],null,true)},[_c(VList,_vm._l((_vm.languageListItems),function(item,index){return _c(VListItem,{key:index,on:{"click":function($event){return _vm.switchLanguage(item.value)}}},[_c(VListItemTitle,[_vm._v(_vm._s(item.title))])],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }